import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'vpColumnFilter'
})
export class VpColumnFilterPipe implements PipeTransform {

  transform(value: Array<any>, args?: any): any {
    const result = value !== undefined && value.filter(v => v['visible']);

    return result;
  }

}
